<template>
<div style="width:100%;height:100%;position:fixed;background:#2d3a4b;">
	<div class="login-container">
		<div class="top-logo" :hidden="hiddenOrNot">

		</div>
		<div style="width:190px;height:45px;position: relative; left: 16px; top: 16px;" :hidden="!hiddenOrNot"></div>
		<!--     <video id="v1" autoplay muted loop style="width: 100%">
      <source src="../../assets/backlogin.mp4">
    </video> -->
		<el-container>
			<el-form class="login-form" autoComplete="on" :model="loginForm" :rules="loginRules" ref="loginForm" label-position="left">
				<div class="title-container">
					<h3 class="title">运营平台</h3>
					<lang-select class="set-language"></lang-select>
				</div>
				<el-form-item prop="username" style='margin-bottom: 20px;'>
					<span class="svg-container svg-container_login">
                       <i class="iconfont icon-user"></i>
                    </span>
					<el-input name="username" type="text" v-model.trim="loginForm.username" autoComplete="off" placeholder="请输入登录账号" />
				</el-form-item>
				<el-form-item prop="password" style='margin-bottom: 20px;'>
					<span class="svg-container">
                      <i class="iconfont icon-et-change-password"></i>
                    </span>
					<el-input name="password" :type="pwdType" @keyup.enter.native="handleLogin" v-model="loginForm.password" autoComplete="on" placeholder="请输入登录密码"></el-input>
					<span class="show-pwd" @click="showPwd"><i :class="{'iconfont':true,'icon-web__kejian':eyeshow, 'icon-web__bukejian':!eyeshow}"></i>
                     </span>
				</el-form-item>
				<el-form-item class="yzmitem" v-if="verificaCodeCount > 1">
					<span class="svg-container">
                        <i class="iconfont icon-et-change-password"></i>
                   </span>
					<el-input class="yzm" maxlength="4" @keyup.enter.native="handleLogin" v-model.number="loginForm.verificaCode" placeholder="验证码"> </el-input>
					<el-tooltip placement="right" effect="light" content="点击刷新验证码">
						<span class="verifica-code-img" @click="replaceCode()">{{initverificaCode}}</span>
					</el-tooltip>
				</el-form-item>
				<div class="save-password">
					<el-checkbox v-model="savePassword">记住密码</el-checkbox>
					<el-tooltip placement="right" effect="light" content="请联系系统管理员">
						<p class="forgot-password pointer">忘记密码？</p>
					</el-tooltip>
				</div>
				<el-form-item>
					<el-button type="primary" style="width:100%;padding:10px 20px;font-size: 14px" :loading="loading" @click.native.prevent="handleLogin">
						{{$t('login.logIn')}}
					</el-button>
				</el-form-item>
				<div class="tips">
					<!-- <span style="margin-right:20px;">{{$t('login.username')}}: admin</span> -->
					<!-- <span> {{$t('login.password')}}: 000000</span> -->
				</div>
        	<div :hidden="true" style="height:180px;font-size:10px;margin-top:100px; left:0; bottom:0px; width:100%; text-align:center;background-color:#2D3A4B;
        box-shadow: 0px 0 0px rgba(0, 0, 0, 0.5);color:white;text-align:center;">
				<div>
					<img style="width:100px;height:100px" :src="sysFileUrl+tpimg" />
					<!--<span @click="dialogVisible = true" style="text-decoration: underline;">管理APP下载</span> &nbsp &nbsp &nbsp
                <span>
               <a href="http://www.xyvending.com" target="_blank" style="text-decoration: underline;">
                 <strong>兴元自动售货机</strong>
                </a>
               </span>-->
				</div>
				<div><span>微信扫码进入管理App</span></div>
				<div style="margin-top: 8px;">
					<a href="https://beian.miit.gov.cn" target="_blank">
						<strong>苏ICP备20004317号-1</strong>
					</a>
				</div>
			</div>
			</el-form>

			<!-- <div style="height:180px;font-size:10px;position:absolute; left:0; bottom:0px; width:100%; text-align:center;background-color:#2D3A4B;
        box-shadow: 0px 0 0px rgba(0, 0, 0, 0.5);color:white;text-align:center;">
				<div>
					<img style="width:100px;height:100px" src='http://www.xynetweb.com:8086/sysFile/app.png' /> -->
					<!--<span @click="dialogVisible = true" style="text-decoration: underline;">管理APP下载</span> &nbsp &nbsp &nbsp
                <span>
               <a href="http://www.xyvending.com" target="_blank" style="text-decoration: underline;">
                 <strong>兴元自动售货机</strong>
                </a>
               </span>-->
				<!-- </div>
				<div><span>扫码下载管理App</span></div>
				<div style="margin-top: 8px;">
					CopyRight ©2018-2020 XINGYUAN NET TECHNICAL
					<a href="http://www.miitbeian.gov.cn" target="_blank">
						<strong>湘ICP备16021985号-3</strong>
					</a>
				</div>
			</div> -->
			<el-dialog style="text-align:center;" title="微信扫码下载微超管家(Android版)" :visible.sync="dialogVisible" width="30%" :before-close="handleClose" append-to-body>
				<div style="padding-top:80px;padding-bottom:80px">
					<img style="width:255px;height:255px" src='http://www.xynetweb.com:8086/sysFile/app.png' />
				</div>
			</el-dialog>
		</el-container>
	</div>
	</div>
</template>

<script>
	import {
		isvalidUsername
	} from "@/utils/validate";
	import {
		mapState,
		mapMutations,
		mapGetters
	} from 'vuex';
	import LangSelect from "@/components/LangSelect";
	import {
		getReplaceCode
	} from "@/api/login";
	import md5 from "js-md5";
	export default {
		components: {
			LangSelect
		},
		name: "login",
		data() {
			const validateUsername = (rule, value, callback) => {
				if(!value) {
					callback(new Error("用户名不能为空"));
				} else {
					callback();
				}
			};
			const validatePass = (rule, value, callback) => {
				if(!value) {
					callback(new Error("请输入密码"));
				} else {
					if(value.length < 6) {
						callback(new Error("密码不能小于6位"));
					} else {
						callback();
					}
				}
			};

			return {
				usermate: this.$globalApi.getSessionStorage('userInfo'),
				dialogVisible: false,
				savePassword: true,
				loginForm: {
					username: this.$globalApi.getLocalStorage("AccountNumber") ?
						this.$globalApi.getLocalStorage("AccountNumber") : "", // 读取用户账号
					password: this.$globalApi.getLocalStorage("AccountPassword") ?
						this.$globalApi.getLocalStorage("AccountPassword") : "", // 读取用户密码
					verificaCode: ""
				},
				loginRules: {
					username: [{
						required: true,
						trigger: "blur",
						validator: validateUsername
					}],
					password: [{
						required: true,
						trigger: "blur",
						validator: validatePass
					}]
				},
				loading: false,
				hiddenOrNot: false,
				pwdType: "password",
				eyeshow: true,
				initverificaCode: "",
				verificaCodeCount: 0, //第一次不显示验证码
				tpimg:'higoApp.png'
			};
		},
		computed: {
			...mapGetters([
				'sysFileUrl'
			]),

		},
		created: function() {
			this.replaceCode();
		},
		mounted(){
			let url = location.href;
			if(url.indexOf('?') >-1){
				this.hiddenOrNot = true;
			}else{
				this.hiddenOrNot = false;
			}
		},

		methods: {
			...mapMutations(['SET_DISPLAY']),
			showPwd() {
				this.eyeshow = !this.eyeshow;
				if(this.pwdType === "password") {
					this.pwdType = "";
				} else {
					this.pwdType = "password";
				}
			},
			handleClose() {},
			handleLogin() {
				this.$store.commit("SET_DISPLAY",this.hiddenOrNot);
				this.$refs.loginForm.validate(valid => {
					if(valid) {
						this.loading = true;
						let password = md5(this.loginForm.username + this.loginForm.password);
						password = md5(
							`${this.loginForm.username}${password}${
              this.loginForm.verificaCode
            }`
						);
						this.$store
							.dispatch("Login", {
								password,
								account: this.loginForm.username,
								checkCode: this.loginForm.verificaCode,
								systemid:"hgsram"
							})
							.then(res => {
								if(res.code) {
									this.replaceCode();
								} else {
									this.loading = false;
									//  debugger;
									console.log(res.userInfo.userid);
									this.$globalApi.setLocalStorage(
										"AccountNumber",
										this.loginForm.username
									); // 储存用户账号
									this.savePassword ?
										this.$globalApi.setLocalStorage(
											"AccountPassword",
											this.loginForm.password
										) :
										this.$globalApi.removeLocalStorage("AccountPassword");
									this.$message({
										message: "登录成功！",
										type: "success"
									});

									if(this.$globalApi.getSessionStorage('userInfo').accountname == 'admin') {
										this.$router.push({
											path: "/database"
										});
									} else {
										this.$router.push({
											path: "/"
										});
									}
									//  this.$router.push({
									//       path: "/"
									//   });
								}
							})
							.catch(error => {
								this.loading = false;
								this.replaceCode();
								this.$message({
									message: error,
									type: "error"
								});
								console.log("登录失败");
							});
					} else {
						console.log("error submit!!");
						return false;
					}
				});
			},
			replaceCode() {
				//获取验证码
				getReplaceCode()
					.then(response => {
						this.loading = false;
						this.initverificaCode = response;
						if(this.verificaCodeCount === 0) {
							this.loginForm.verificaCode = response;
						} else {
							this.loginForm.verificaCode = null;
						}
						this.verificaCodeCount++;
					})
					.catch(error => {
						this.loading = false;
						this.initverificaCode = "0000";
						if(this.verificaCodeCount === 0) {
							this.loginForm.verificaCode = "0000";
						} else {
							this.loginForm.verificaCode = null;
						}
						this.verificaCodeCount++;
					});
			}
		}
	};
</script>

<style lang="scss">
	beforeClose .verifica-code-img {
		display: inline-block;
		width: 105px;
		float: right;
		height: 47px;
		margin-left: 0px;
		line-height: 47px;
		text-align: center; // border-radius: 3px;
		background-color: #bfeefe;
		font-size: 16px;
		cursor: pointer;
		letter-spacing: 7px;
		color: #0300ff;
	}

	$bg: #2d3a4b;
	$light_gray: #ecf5ff;
	.login-container {
		div.yzm {
			width: 50%;
		}
		.el-input {
			display: inline-block;
			height: 47px;
			width: 85%;
			input {
				background: transparent;
				border: 0px;
				-webkit-appearance: none;
				border-radius: 0px;
				padding: 12px 5px 12px 15px;
				color: $light_gray;
				height: 47px;
				&:-webkit-autofill {
					-webkit-box-shadow: 0 0 0px 1000px $bg inset !important;
					-webkit-text-fill-color: #fff !important;
				}
			}
		}
		.login-container .yzmitem .el-form-item__content {}
		.el-form-item {
			width: 100%;
			border: 1px solid rgba(255, 255, 255, 0.1);
			background: rgba(0, 0, 0, 0.1);
			border-radius: 5px;
			color: #409FFF;
		}
	}

	.verifica-code-img {
		display: inline-block;
		width: 105px;
		float: right;
		height: 47px;
		margin-left: 0px;
		line-height: 47px;
		text-align: center; // border-radius: 3px;
		background-color: #bfeefe;
		font-size: 16px;
		cursor: pointer;
		letter-spacing: 7px;
		color: #0300ff;
	}
</style>

<style lang="scss" scoped>
html, body {height: 100%;}
	$bg: #2d3a4b;
	$dark_gray: #889aa4;
	$light_gray: #eee;
	.login-container {
		position: fixed;
		//height: 100%;
    //height: 800px;
		width: 100%;
		background-color: $bg;
		.login-form {
			//position: absolute;
			left: 0;
			right: 0;
			width: 520px;
			padding: 0px 35px 15px 35px;
			margin: 0px auto;
			margin-top: 15vh;
		}
		.tips {
			font-size: 14px;
			color: #fff;
			margin-bottom: 10px;
			span {
				&:first-of-type {
					margin-right: 16px;
				}
			}
		}
		.svg-container {
			padding: 6px 5px 6px 15px;
			color: $dark_gray;
			vertical-align: middle;
			width: 30px;
			display: inline-block;
			&_login {
				font-size: 20px;
			}
		}
		.title-container {
			position: relative;
			.title {
				font-size: 26px;
				font-weight: 400;
				color: $light_gray;
				margin: 0px auto 40px auto;
				text-align: center;
				font-weight: bold;
			}
			.set-language {
				color: #fff;
				position: absolute;
				top: 5px;
				right: 0px;
			}
		}
		.show-pwd {
			.iconfont {
				font-size: 22px;
			}
			position: absolute;
			right: 10px;
			top: 10px;
			font-size: 16px;
			color: $dark_gray;
			cursor: pointer;
			user-select: none;
		}
		.thirdparty-button {
			position: absolute;
			right: 35px;
			bottom: 28px;
		}
	}

	.save-password {
		display: flex;
		align-items: center;
		margin-bottom: 10px;
		color: #acacac;
		font-size: 14px;
		margin-top: -10px;
		justify-content: space-between;
	}

	.save-password .forgot-password {
		position: relative;
		top: -1px;
	}

	.save-password .forgot-password:hover {
		color: #20a0ff;
	}

	.el-checkbox,
	.el-checkbox.is-checked {
		color: #acacac;
	}
</style>
<style type="text/css">
	.top-logo{
		width:190px;
		height:45px;
		position: relative;
		left: 16px;
		top: 16px;
		background: url(../../../static/lq.png) no-repeat;
		background-size: 100% 100%;
	}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue